import { render, staticRenderFns } from "./OfferDiscount.vue?vue&type=template&id=4bb63526&"
import script from "./OfferDiscount.vue?vue&type=script&lang=js&"
export * from "./OfferDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports